<template>
  <div class="banner">
    <div>
      <div class="banner__subtitle">{{ subtitle }}</div>
      <div class="banner__title">{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: String,
    subtitle: String,
  },
};
</script>

<style scoped lang="scss">
.banner {
  min-height: 200px;
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: url(~@/assets/banner.png);
  background-size: cover;
  background-position: center;

  &__subtitle {
    font-family: "Roboto", sans-serif;
    font-weight: 600;
    font-size: 24px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #f2a900;
  }

  &__title {
    font-family: "Roboto", sans-serif;
    font-weight: 600;
    font-size: 64px;
    text-align: center;
    color: #ffffff;
  }
}

@media screen and (max-width: 960px) {
  .banner {
    min-height: 130px;

    &__subtitle {
      font-size: 18px;
    }
    &__title {
      font-size: 36px;
    }
  }
}
</style>
